import { createAsyncThunk, AnyAction } from "@reduxjs/toolkit"
import { ThunkDispatch } from "redux-thunk"

import { API } from "redux/api"
import i18n from "config/i18n"
import { ClientConfirmPhoneValues } from "types"

export const resendPhoneConfirmation = createAsyncThunk(
  "client/resend-phone-confirmation",
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await API.post("/client/confirm_phone/resend")
      if (response.status >= 400) {
        return rejectWithValue(response.data)
      }
      return fulfillWithValue(response.data)
    } catch (error) {
      throw rejectWithValue(error)
    }
  },
)

export const cancelPhoneConfirmation = createAsyncThunk(
  "client/cancel-phone-confirmation",
  async () => {
    const response = await API.post("/client/confirm_phone/reset")
    return response.data
  },
)

export const confirmPhone = createAsyncThunk(
  "client/confirm-phone",
  async (values: ClientConfirmPhoneValues) => {
    const response = await API.post("/client/confirm_phone", values)
    return response.data
  },
)

export const makeResendPhoneConfirmation = () => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(resendPhoneConfirmation())
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.phone.resend.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(i18n.t("notice.confirmation.phone.resend.success"))
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.phone.resend.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export const makeCancelPhoneConfirmation = () => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(cancelPhoneConfirmation())
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.phone.cancel.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(i18n.t("notice.confirmation.phone.cancel.success"))
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.phone.resend.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export const makePhoneConfirmation = (values: ClientConfirmPhoneValues) => {
  return function (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) {
    return new Promise((resolve, reject) => {
      return dispatch(confirmPhone(values))
        .then(
          ({ payload }) => {
            if (!payload) {
              return reject(i18n.t("notice.confirmation.phone.confirm.failure"))
            } else if (payload["error"]) {
              return reject(payload["error"])
            } else {
              return resolve(
                i18n.t("notice.confirmation.phone.confirm.success"),
              )
            }
          },
          () => {
            reject(i18n.t("notice.confirmation.phone.confirm.failure"))
          },
        )
        .catch((error) => {
          reject(error)
        })
    })
  }
}
